<template>
  <div>
    <modal id="copyTasks">
      <h3>Prozessschritte kopieren</h3>
      <div v-if="copyTasksShowLoading">
        <p>Prozessschritte werden kopiert - bitte warten</p>
      </div>
      <div v-else-if="copyTasksShowWarning">
        <p>
          <b>Achtung:</b> die aktuelle Messe enthält bereits Prozessschritte - diese werden vor dem kopieren entfernt!<br />
          Willst Du mit dem Kopieren fortfahren?
        </p>
        <bos-button @click="closeCopyTasks" style="margin-bottom: 10px">Nein, aktuelle Prozessschritte behalten</bos-button>
        <bos-button @click="doCopyTasks" color="red">Ja, aktuelle Prozessschritte überschreiben</bos-button>
      </div>
      <div v-else>
        <div v-if="fairlisting === null">Lade...</div>
        <div v-else>
          <bos-input
            v-model="copyTasksSource"
            label="Quelle:"
            @setOptions="setCopyTasksSource"
            type="dropdown"
            :required="true"
          />
          <bos-button @click="showCopyTasksWarning" :disabled="copyTasksSource === null">Prozessschritte kopieren</bos-button>
        </div>
      </div>
    </modal>
    <modal id="setDates">
      <h3>Datum für alle Prozessschritte setzen</h3>
      <div>
        <p>
          <b>Achtung:</b> Die Änderungen werden erst übernommen, nachdem die Messe gespeichert wurde.<br />
        </p>
        <bos-input
          v-model="globalperiod"
          label="Frist (von/bis):"
          type="daterange"
        />
        <bos-button @click="closeSetDates" style="margin-bottom: 10px; margin-right: 20px">Abbrechen</bos-button>
        <bos-button @click="doSetDates" color="red">Datum setzen</bos-button>
      </div>
    </modal>
    <modal id="editTask"
           :noCloseButton="true"
           :noEscapeByMask="true"
           :noEscapeByKeyboard="true"
           variant="big"
      >
      <div class="bos-button-group">
        <div><bos-button @click="saveTaskEdit">übernehmen</bos-button></div>
        <div><bos-button @click="cancelTaskEdit" color="red">abbrechen</bos-button></div>
      </div>

      <div v-if="editStep && editStep.type === 'task'">
        <h3>Prozess-Details</h3>
        <h4>{{ editStep.displayNameDe }}</h4>

        <bos-input
          type="checkbox"
          label="Typ"
          id="mandatoryStep"
          v-model="editStep.required"
          style="display: inline-block; min-height: auto; padding: 0;"
          @input="updateBoothServiceRequired()"
        >
          <label for="mandatoryStep">
            Dies ist eine Pflichtaufgabe.
          </label>
        </bos-input>
        <bos-input
          v-model="editStep.period"
          label="Frist (von/bis):"
          type="daterange"
        />
        <bos-input
          v-model="editStep.urlDe"
          label="Deeplink (de):"
          v-if="editStep.deeplinkmode === 'manual'"
        />
        <bos-input
          v-model="editStep.urlFr"
          label="Deeplink (fr):"
          v-if="editStep.deeplinkmode === 'manual'"
        />
        <bos-input
          v-model="editStep.urlEn"
          label="Deeplink (en):"
          v-if="editStep.deeplinkmode === 'manual'"
        />
        <bos-input
          type="checkbox"
          label="Deeplink verhalten"
          v-model="editStep.manualdeeplinktargetblank"
          v-if="
                    editStep.deeplinkmode === 'manual'
                  "
          id="manualdeeplinktargetblank"
        >
          <label for="manualdeeplinktargetblank">
            in neuem Fenster / Tab öffnen
          </label>
        </bos-input>

        <bos-input
          type="checkbox"
          label="Mitaussteller"
          v-model="editStep.coexposant"
          v-if="
                    editStep.deeplinkmode === 'manual' || editStep.serviceGroup === 'VERS'
                  "
          id="coexposant"
        >
          <label for="coexposant">
            Dieser Schritt gilt für Aussteller und Mitaussteller
          </label>
        </bos-input>

        {{ /* Booth Services. */ }}
        <h3>Stand-Leistungen</h3>
        <div class="o-grid">
          <div class="o-grid__cell--width-40">
            <b>Titel</b>
          </div>
          <div class="o-grid__cell--width-20">
            <b>Ausblenden</b>
          </div>
          <div class="o-grid__cell--width-20">
            <b>Pflicht</b>
          </div>
          <div class="o-grid__cell--width-20">
            <b>Optional</b>
          </div>
        </div>
        <div class="boothservices">
          <div
            class="o-grid"
            v-for="boothService in editStep.boothServices" v-bind:key="boothService.id"
          >
            <div class="o-grid__cell--width-40">
              {{
              boothServices.find(item => item.id === boothService.id)
              .title
              }}
            </div>
            <div class="o-grid__cell--width-20">
              <input
                type="checkbox"
                id="boothservice_hidden"
                v-model="boothService.hidden"
                style="display: inline-block; min-height: auto; padding: 0;"
              />
            </div>
            <div class="o-grid__cell--width-20">
              <input
                type="radio"
                :name="'boothservice_required_' + boothService.id"
                v-model="boothService.required"
                :value="true"
                style="display: inline-block; min-height: auto; padding: 0;"
              />
            </div>
            <div class="o-grid__cell--width-20">
              <input
                type="radio"
                :name="'boothservice_required_' + boothService.id"
                v-model="boothService.required"
                :value="false"
                style="display: inline-block; min-height: auto; padding: 0;"
              />
            </div>
          </div>
        </div>

        {{ /* Additional  texts. */ }}
        <h3>Zusätzliche Informationstexte</h3>
        <div
          v-for="(text, index) in editStep.infoTexts"
          :key="index"
          class="u-letter-box-medium"
        >
          <div class="c-divider c-divider--dashed"></div>
          <div class="o-grid o-grid--no-gutter">
            <div class="o-grid__cell">
              <h4>Infotext {{ index + 1 }}</h4>
            </div>
            <div class="o-grid__cell u-right">
              <bos-button
                @click="markInfoTextForDeletion(index)"
                color="red"
                small
                ghost
              >
                <font-awesome-icon icon="trash" />
              </bos-button>
            </div>
          </div>

          <bos-input v-model="text.textDe" label="Text (de):" />
          <bos-input v-model="text.textFr" label="Text (fr):" />
          <bos-input v-model="text.textEn" label="Text (en):" />
          <bos-input
            v-model="text.publish"
            label="Publikation (von/bis):"
            type="daterange"
          />
        </div>
        <bos-button @click="addInfotext" small>
          + Infotext hinzufügen
        </bos-button>

        {{ /* Header text for external components. */ }}
        <h3>Header-Infotext</h3>
        <div class="u-letter-box-medium">
          <div class="c-divider c-divider--dashed"></div>
          <bos-input
            v-model="editStep.headerTextDe"
            label="Header-Info (de):"
            type="wysiwyg"
          />
          <bos-input
            v-model="editStep.headerTextFr"
            label="Header-Info (fr):"
            type="wysiwyg"
          />
          <bos-input
            v-model="editStep.headerTextEn"
            label="Header-Info (en):"
            type="wysiwyg"
          />
        </div>
      </div>
      <div v-else-if="editStep && editStep.type === 'taskTitle'">
        <h3>Prozessgruppe-Details</h3>
        <h4>{{ editStep.titleDe }}</h4>

        <bos-input
          v-model="editStep.urlDe"
          label="Deeplink (de):"
          v-if="editStep.deeplinkmode === 'manual'"
        />
        <bos-input
          v-model="editStep.urlFr"
          label="Deeplink (fr):"
          v-if="editStep.deeplinkmode === 'manual'"
        />
        <bos-input
          v-model="editStep.urlEn"
          label="Deeplink (en):"
          v-if="editStep.deeplinkmode === 'manual'"
        />
        <bos-input
          type="checkbox"
          label="Deeplink verhalten"
          v-model="editStep.manualdeeplinktargetblank"
          v-if="
                    editStep.deeplinkmode === 'manual'
                  "
          id="manualdeeplinktargetblank"
        >
          <label for="manualdeeplinktargetblank">
            in neuem Fenster / Tab öffnen
          </label>
        </bos-input>

        {{ /* Header text for external components. */ }}
        <h3>Header-Infotext</h3>
        <div class="u-letter-box-medium">
          <div class="c-divider c-divider--dashed"></div>
          <bos-input
            v-model="editStep.headerTextDe"
            label="Header-Info (de):"
            type="wysiwyg"
          />
          <bos-input
            v-model="editStep.headerTextFr"
            label="Header-Info (fr):"
            type="wysiwyg"
          />
          <bos-input
            v-model="editStep.headerTextEn"
            label="Header-Info (en):"
            type="wysiwyg"
          />
        </div>
      </div>

      <div class="bos-button-group">
        <div><bos-button @click="saveTaskEdit">übernehmen</bos-button></div>
        <div><bos-button @click="cancelTaskEdit" color="red">abbrechen</bos-button></div>
      </div>
    </modal>
    <modal id="deleteInfoText">
      <h3>Infotext löschen</h3>
      <br />
      Soll dieser Infotext wirklich gelöscht werden?<br />
      <br />
      <a @click="doDeleteInfoText()">Ja</a>&nbsp;
      <a @click="closeModal('deleteInfoText')">Nein</a>
    </modal>
    <modal id="deleteTask">
      <h3>
        <span v-if="deleteTask.type === 'task'">Prozessschritt</span
        ><span v-if="deleteTask.type === 'taskTitle'">Prozessgruppe</span>
        löschen
      </h3>
      <br />
      Soll
      <span v-if="deleteTask.type === 'task'"
        >der Prozessschritt "{{ deleteTask.displayNameDe }}"</span
      ><span v-if="deleteTask.type === 'taskTitle'"
        >die Prozessgruppe "{{ deleteTask.titleDe }}"</span
      >
      wirklich gelöscht werden?<br />
      <br />
      <a @click="doDeleteTask()">Ja</a>&nbsp;
      <a @click="closeModal('deleteTask')">Nein</a>
    </modal>
    <modal id="deleteFlowStep">
      <h3>Teilschritt löschen</h3>
      <br />
      Soll der Teilschritt
      <b>"{{ deleteFlowStep.displayNameDe }}"</b> wirklich gelöscht werden?<br />
      <br />
      <a @click="doDeleteFlowStep()">Ja</a>&nbsp;
      <a @click="closeModal('deleteFlowStep')">Nein</a>
    </modal>
    <modal id="deleteDoc">
      <h3>Dokument löschen</h3>
      <br />
      Soll das Dokument
      <b>"{{ deleteDoc.titleDe }}"</b> wirklich gelöscht werden?<br />
      <br />
      <a @click="doDeleteDoc(deleteDoc)">Ja</a>&nbsp;
      <a @click="closeModal('deleteDoc')">Nein</a>
    </modal>
    <section>
      <b-alert
        :show="successMessageDismissCountdown"
        dismissible
        variant="success"
        @dismissed="successMessageDismissCountdown = 0"
        @dismiss-count-down="countDownChanged"
      >
        <p>
          Die Messe "{{ fair.displayNameDe }}" wurde erfolgreich gespeichert
        </p>
      </b-alert>
      <h2 v-if="!fair._id">Neue Messe erfassen</h2>
      <h2 v-if="fair._id">Messe bearbeiten</h2>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell  o-grid__cell--width-70">
          <ul class="bos-timeflow">
            <li class="active"><span>Eröffnen</span></li>
            <li :class="{ active: fair._id }"><span>Erfasst</span></li>
            <li
              :class="{
                active: fair._id && fairPublishStarted()
              }"
            >
              <span>Aktiv</span>
            </li>
            <li
              :class="{
                active: fair._id && fairPublishEnded()
              }"
            >
              <span>Beendet</span>
            </li>
          </ul>
        </div>
        <div class="o-grid__cell top-buttons">
          <bos-button :ghost="true" color="red" v-if="1 === 2"
            >Messe löschen
          </bos-button>
          <bos-button @click="saveFair">Messe speichern</bos-button>
        </div>
      </div>
    </section>
    <section>
      <tabs
        :options="{ useUrlFragment: false }"
        @clicked="tabClicked"
        @changed="tabChanged"
        class="bos-tabs"
      >
        <tab name="Messedaten">
          <div class="o-grid o-grid--no-gutter">
            <div class="o-grid__cell o-grid__cell--width-60">
              <bos-input
                v-model="fair.displayNameDe"
                label="Anzeigename (de):"
                :error="errors.displayNameDe"
                :required="true"
              />
              <bos-input
                v-model="fair.displayNameFr"
                :error="errors.displayNameFr"
                label="Anzeigename (fr):"
                :required="true"
              />
              <bos-input
                v-model="fair.displayNameEn"
                :error="errors.displayNameEn"
                label="Anzeigename (en):"
                :required="true"
              />

              <hr />

              <bos-input
                v-model="fair.idCode"
                label="Messe ID:"
                :error="errors.idCode"
                :required="true"
              />

              <bos-input
                v-model="fair.fairSeries"
                label="Messe-Reihe:"
                :error="errors.fairSeries"
                @setOptions="setFairSeries"
                type="dropdown"
                :required="true"
              />

              <hr />

              <bos-input
                label="E-Mail Messe-Team:"
                v-model="fair.emailTeam"
                :error="errors.emailTeam"
                :required="true"
              />

              <bos-input
                label="ID Messe-Team:"
                v-model="fair.idTeam"
                :error="errors.idTeam"
                :required="true"
              />

              <hr />

              <bos-input
                label="RUBIN Initial-Anmeldung (URL - de):"
                v-model="fair.defaultRegistrationUrlDe"
                :error="errors.defaultRegistrationUrlDe"
                :required="true"
              />
              <bos-input
                label="RUBIN Initial-Anmeldung Gastro (URL - de):"
                v-model="fair.defaultGastroRegistrationUrlDe"
                :required="true"
              />
              <bos-input
                label="RUBIN Initial-Anmeldung (URL - fr):"
                v-model="fair.defaultRegistrationUrlFr"
                :error="errors.defaultRegistrationUrlFr"
                :required="true"
              />
              <bos-input
                label="RUBIN Initial-Anmeldung Gastro (URL - fr):"
                v-model="fair.defaultGastroRegistrationUrlFr"
                :required="true"
              />
              <bos-input
                label="RUBIN Initial-Anmeldung (URL - en):"
                v-model="fair.defaultRegistrationUrlEn"
                :error="errors.defaultRegistrationUrlEn"
                :required="true"
              />
              <bos-input
                label="RUBIN Initial-Anmeldung Gastro (URL - en):"
                v-model="fair.defaultGastroRegistrationUrlEn"
                :required="true"
              />
            </div>
            <div
              class="o-grid__cell o-grid__cell--width-35 o-grid__cell--offset-5"
            >
              <bos-input
                label="Durchführung (von/bis):"
                type="daterange"
                :required="true"
                v-model="fair.duration"
                :value="fair.duration"
                :error="errors.duration"
              />
              <bos-input
                label="Publikationsdatum (von/bis):"
                type="daterange"
                :required="true"
                v-model="fair.publish"
                value="fair.publish"
                :error="errors.publish"
              />
              <bos-input
                label="Anmeldeschluss:"
                type="date"
                :required="true"
                v-model="fair.registrationDeadline"
                value="fair.registrationDeadline"
                :error="errors.registrationDeadline"
              />

              <bos-input
                label="Dokumente sichtbar ab:"
                type="date"
                :value="fair.documentsstartdate"
                v-model="fair.documentsstartdate"
              />

              <image-uploader
                :debug="1"
                :maxWidth="400"
                :maxHeight="400"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="['fileinput']"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageDe"
                id="fileInput"
              >
                <label for="fileInput" slot="upload-label"
                  >Messe-Logo De:</label
                >
              </image-uploader>
              <div v-if="fair.logoDe">
                <img v-bind:src="fair.logoDe" /><br />
                <a @click="clearImage" data-image="logoDe">Bild entfernen</a
                ><br />
                <br />
              </div>
              <image-uploader
                :debug="1"
                :maxWidth="400"
                :maxHeight="400"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="['fileinput']"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageFr"
                id="fileInput"
              >
                <label for="fileInput" slot="upload-label"
                  >Messe-Logo Fr:</label
                >
              </image-uploader>
              <div v-if="fair.logoFr">
                <img v-bind:src="fair.logoFr" /><br />
                <a @click="clearImage" data-image="logoFr">Bild entfernen</a
                ><br />
                <br />
              </div>
              <image-uploader
                :debug="1"
                :maxWidth="400"
                :maxHeight="400"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="['fileinput']"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageEn"
                id="fileInput"
              >
                <label for="fileInput" slot="upload-label"
                  >Messe-Logo En:</label
                >
              </image-uploader>
              <div v-if="fair.logoEn">
                <img v-bind:src="fair.logoEn" /><br />
                <a @click="clearImage" data-image="logoEn">Bild entfernen</a
                ><br />
                <br />
              </div>
            </div>
          </div>
        </tab>
        <tab name="Prozesskonfiguration">
          <div class="o-grid o-grid--no-gutter o-grid--wrap">
            <div class="o-grid__cell o-grid__cell--width-100 text-right">
              <bos-button style="margin-right: 20px" @click="showSetDate">Datum für alle Prozessschritte</bos-button>
              <bos-button @click="showCopyTasks">Prozessschritte kopieren</bos-button>
            </div>
            <div class="o-grid__cell o-grid__cell--width-33">
              <h4>Aktive Prozessschritte</h4>
              <div class="processStepError" v-if="processStepError">
                Die Prozessschritte müssen mit einer Prozessgruppe beginnen
              </div>
              <draggable
                style="min-height: 1.333rem; width: 100%;"
                v-model="fair.tasks"
                :group="currentDraggingGroup"
                :class="{ empty: fair.tasks.length === 0 }"
                ghost-class="ghost"
                @start="currentDraggingGroup = 'nowhere'"
                @add="checkBoothServices()"
                @end="processStepError = false"
              >
                <transition-group type="transition" :name="'flip-list'">
                  <div
                    v-for="(element, index) in fair.tasks"
                    :key="index"
                    class="list-group-item"
                    :class="'list-group-item__' + element.type.toLowerCase()"
                  >
                    <div class="o-grid">
                      <div class="o-grid__cell o-grid__cell--width-5">
                        <font-awesome-icon icon="arrows-alt" />
                      </div>
                      <div class="o-grid__cell ellipsis" v-if="element.type === 'task'">
                        {{ element.displayNameDe }}
                        <div v-if="element.serviceGroup">
                          <span class="serviceGroup">({{ element.serviceGroup }})</span>
                        </div>
                      </div>
                      <div
                        class="o-grid__cell ellipsis"
                        v-if="element.type === 'taskTitle'"
                      >
                        <b>{{ element.titleDe }}</b>
                        <div v-if="element.serviceGroup">
                          <span class="serviceGroup">({{ element.serviceGroup }})</span>
                        </div>
                      </div>
                      <div
                        class="o-grid__cell o-grid__cell--width-40 u-right"
                        style="white-space: nowrap;"
                      >
                        <bos-button
                          ghost
                          icon
                          borderless
                          @click.prevent="setEditStep(element)"
                        >
                          <font-awesome-icon
                            icon="edit"
                          /> </bos-button
                        >&nbsp;
                        <bos-button ghost icon borderless color="red" @click="markTaskForDeletion(element)">
                          <font-awesome-icon
                            icon="trash"
                          />
                        </bos-button>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
            <div class="o-grid__cell o-grid__cell--width-33">
              <h4>Inaktive Prozessschritte</h4>
              <draggable
                v-model="inactiveSteps"
                group="stepper"
                ghost-class="ghost"
                @start="currentDraggingGroup = 'stepper'"
                @end="processStepError = false"
                :class="{ empty: inactiveSteps.length === 0 }"
                style="min-height: 1.333rem; width: 100%;"
              >
                <transition-group type="transition" :name="'flip-list'">
                  <div
                    v-for="element in inactiveSteps"
                    :key="element._id"
                    class="list-group-item"
                    data-group="stepper"
                  >
                    <div class="o-grid">
                      <div class="o-grid__cell o-grid__cell--width-5">
                        <font-awesome-icon icon="arrows-alt" />
                      </div>
                      <div class="o-grid__cell ellipsis">
                        {{ element.displayNameDe }}
                        <div v-if="element.serviceGroup">
                          <span class="serviceGroup">({{ element.serviceGroup }})</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
            <div class="o-grid__cell o-grid__cell--width-33">
              <h4>Inaktive Prozessgruppen</h4>
              <draggable
                v-model="inactiveTaskTitles"
                group="stepper2"
                ghost-class="ghost"
                :class="{ empty: inactiveTaskTitles.length === 0 }"
                style="min-height: 1.333rem; width: 100%;"
                @start="currentDraggingGroup = 'stepper2'"
                @end="processStepError = false"
              >
                <transition-group type="transition" :name="'flip-list'">
                  <div
                    v-for="element in inactiveTaskTitles"
                    :key="element._id"
                    class="list-group-item"
                    data-group="stepper2"
                  >
                    <div class="o-grid">
                      <div class="o-grid__cell o-grid__cell--width-5">
                        <font-awesome-icon icon="arrows-alt" />
                      </div>
                      <div class="o-grid__cell ellipsis">
                        {{ element.titleDe }}
                        <div v-if="element.serviceGroup">
                          <span class="serviceGroup">({{ element.serviceGroup }})</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </tab>
        <tab name="Dokumente" :is-disabled="false">
          <draggable
            v-model="fair.documents"
            group="steps"
            @start="drag = true"
            @end="drag = false"
            class="doc-group"
            ghost-class="ghost"
          >
            <transition-group type="transition" :name="'flip-list'">
              <div
                v-for="(element, index) in fair.documents"
                :key="index"
                class="list-group-item"
              >
                <div class="o-grid">
                  <div class="o-grid__cell o-grid__cell--width-5">+</div>
                  <div class="o-grid__cell">{{ element.titleDe }}</div>
                  <div class="o-grid__cell">{{ element.publish }}</div>
                  <div class="o-grid__cell o-grid__cell--width-20 u-right">
                    <bos-button ghost icon @click="reopenDoc(element)">
                      <font-awesome-icon icon="edit" />
                    </bos-button>
                    <bos-button
                      ghost
                      icon
                      color="red"
                      @click="markDocForDeletion(element)"
                    >
                      <font-awesome-icon icon="trash" />
                    </bos-button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="c-card" v-if="fair.documents.length === 0">
            <div class="c-card__body u-centered">
              Noch keine Dokumente vorhanden.
            </div>
          </div>
          <bos-a-divider />
          <bos-admin-document-form
            ref="docForm"
            v-model="editDoc"
            @input="updateDoc"
            @onclear="editDoc = {}"
          />
        </tab>
        <tab name="Ablauf Messe">
          <draggable
            v-model="fair.steps"
            group="steps"
            @start="drag = true"
            @end="drag = false"
            class="list-group"
            ghost-class="ghost"
          >
            <transition-group type="transition" :name="'flip-list'">
              <div
                v-for="(element, index) in fair.steps"
                :key="index"
                class="list-group-item"
              >
                <div class="o-grid">
                  <div class="o-grid__cell o-grid__cell--width-5">+</div>
                  <div class="o-grid__cell">{{ element.displayNameDe }}</div>
                  <div class="o-grid__cell">{{ element.dateRange.start }}</div>
                  <div class="o-grid__cell">{{ element.dateRange.end }}</div>
                  <div class="o-grid__cell o-grid__cell--width-20 u-right">
                    <bos-button ghost icon @click="reopenStep(element)">
                      <font-awesome-icon icon="edit" />
                    </bos-button>
                    <bos-button
                      ghost
                      icon
                      color="red"
                      @click="markFlowStepForDeletion(element)"
                    >
                      <font-awesome-icon icon="trash" />
                    </bos-button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="c-card" v-if="fair.steps.length === 0">
            <div class="c-card__body u-centered">
              Noch keine Teilschritte vorhanden.
            </div>
          </div>
          <bos-a-divider />
          <bos-admin-step-form
            ref="stepForm"
            v-model="editFlowStep"
            @input="updateFlowStep"
            @onclear="editFlowStep = {}"
          />
        </tab>
        <tab name="Zusatzinformationen">
          <bos-input
            v-model="fair.additionalInfoDe"
            label="Freitext (de):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.additionalInfoFr"
            label="Freitext (fr):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.additionalInfoEn"
            label="Freitext (en):"
            type="wysiwyg"
          />
          <h3>Statustexte</h3>
          <bos-input
            v-model="fair.stateLabelOverrideOpenDe"
            label="Offen (de):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideOpenFr"
            label="Offen (fr):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideOpenEn"
            label="Offen (en):"
            type="wysiwyg"
          />
          <hr />
          <bos-input
            v-model="fair.stateLabelOverrideOrderedDe"
            label="Bestellt (de):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideOrderedFr"
            label="Bestellt (fr):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideOrderedEn"
            label="Bestellt (en):"
            type="wysiwyg"
          />
          <hr />
          <bos-input
            v-model="fair.stateLabelOverrideEvaluationDe"
            label="In Prüfung (de):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideEvaluationFr"
            label="In Prüfung (fr):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideEvaluationEn"
            label="In Prüfung (en):"
            type="wysiwyg"
          />
          <hr />
          <bos-input
            v-model="fair.stateLabelOverrideConfirmedDe"
            label="Geprüft (de):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideConfirmedFr"
            label="Geprüft (fr):"
            type="wysiwyg"
          />
          <bos-input
            v-model="fair.stateLabelOverrideConfirmedEn"
            label="Geprüft (en):"
            type="wysiwyg"
          />

        </tab>
      </tabs>
    </section>
  </div>
</template>

<script>
import { Tabs, Tab } from 'vue-tabs-component'
import BosButton from '@/components/BosButton'
import BosInput from '@/components/BosInput'
import BosAdminStepForm from '@/components/BosAdminStepForm'
import BosADivider from '@/components/BosADivider'
import draggable from 'vuedraggable'
import BosAdminDocumentForm from '@/components/BosAdminDocumentForm'
import ApiService from '@/services/ApiService'
import FormValidator from '@/services/FormValidator'
import UUIDService from '@/services/UUIDService'
import Modal from '@/components/Modal'
import { BAlert } from 'bootstrap-vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'AdminCreateFair',
  components: {
    BosAdminDocumentForm,
    BosADivider,
    BosAdminStepForm,
    BosInput,
    BosButton,
    Tabs,
    Tab,
    draggable,
    Modal,
    BAlert
  },
  props: {
    msg: String
  },
  data() {
    return {
      fairlisting: null,
      copyTasksShowWarning: false,
      copyTasksShowLoading: false,
      copyTasksSource: null,
      processStepError: false,
      successMessageDismissCountdown: 0,
      currentDraggingGroup: '',
      docs: [],
      steps: [],
      boothServices: [],
      editStep: null,
      globalperiod: null,
      inactiveSteps: [],
      inactiveTaskTitles: [],
      editDoc: {},
      deleteDoc: {},
      deleteTask: {},
      deleteInfoText: null,
      fair: {
        logo: null,
        tasks: [],
        documents: [],
        steps: [],
        additionalInfoDe: null,
        additionalInfoFr: null,
        additionalInfoEn: null
      },
      editFlowStep: {},
      deleteFlowStep: {},
      errors: {
        displayNameDe: {
          hasError: false
        },
        displayNameFr: {
          hasError: false
        },
        displayNameEn: {
          hasError: false
        },
        idCode: {
          hasError: false
        },
        fairSeries: {
          hasError: false
        },
        emailTeam: {
          hasError: false
        },
        idTeam: {
          hasError: false
        },
        defaultRegistrationUrlDe: {
          hasError: false
        },
        defaultRegistrationUrlFr: {
          hasError: false
        },
        defaultRegistrationUrlEn: {
          hasError: false
        },
        duration: {
          hasError: false
        },
        publish: {
          hasError: false
        },
        registrationDeadline: {
          hasError: false
        }
      }
    }
  },
  methods: {
    showCopyTasks() {
      this.copyTasksSource = null;
      this.copyTasksShowWarning = false;
      this.copyTasksShowLoading = false;
      ApiService.getFairs().then(response => {
        this.fairlisting = response.data
      })
      this.$root.$emit('modal:copyTasks:show')
    },
    showSetDate() {
      this.globalperiod = null;
      this.$root.$emit('modal:setDates:show');
    },
    doSetDates() {
      console.log(this.globalperiod);
      this.fair.tasks.forEach((item) => {
        if (item.type === 'task') {
          item.period = this.globalperiod;
        }
      });
      this.closeSetDates();
    },
    closeSetDates() {
      this.$root.$emit('modal:setDates:hide')
    },
    showCopyTasksWarning() {
      if (this.fair.tasks.length > 0) {
        this.copyTasksShowWarning = true;
      } else {
        this.doCopyTasks()
      }
    },
    doCopyTasks() {
      this.copyTasksShowLoading = true;
      ApiService.getFair(this.copyTasksSource).then(res => {
        this.fair.tasks = res.data.tasks;
        this.setCurrentFair(this.fair);
        this.fair.tasks.forEach((item) => {
          if (item.period !== undefined) {
            delete item.period;
          }
        });
        this.$root.$emit('modal:copyTasks:hide');
      })
    },
    closeCopyTasks() {
      this.$root.$emit('modal:copyTasks:hide')
    },
    setCopyTasksSource(options) {
      while (options.length > 0) {
        options.pop()
      }
      options.push({
        value: '',
        text: '-'
      })
      for (var i = 0; i < this.fairlisting.length; i++) {
        if (this.fairlisting[i]._id !== this.$route.params.id) {
          options.push({
            value: this.fairlisting[i]._id,
            text: this.fairlisting[i].displayNameDe
          })
        }
      }
    },
    closeTaskEdit() {
      this.$root.$emit('modal:editTask:hide')
      this.editStep = null;
    },
    cancelTaskEdit() {
      this.closeTaskEdit();
    },
    saveTaskEdit() {
      const orig = this.fair.tasks.filter((item) => item._id === this.editStep._id)[0];
      const pos = this.fair.tasks.indexOf(orig);
      this.fair.tasks[pos] = this.editStep;
      this.closeTaskEdit();
    },
    updateBoothServiceRequired() {
      this.editStep.boothServices.forEach(boothService => {
        boothService.required = this.editStep.required
      })
    },
    fairPublishStarted() {
      if (this.fair.publish && this.fair.publish.start) {
        const startTime = new Date(this.fair.publish.start)
        const now = new Date()
        return startTime <= now
      }
      return false
    },
    fairPublishEnded() {
      if (this.fair.publish && this.fair.publish.end) {
        const endTime = new Date(this.fair.publish.end)
        endTime.setUTCHours(23)
        endTime.setUTCMinutes(59)
        endTime.setUTCSeconds(59)
        endTime.setUTCMilliseconds(999)
        const now = new Date()
        return endTime <= now
      }
      return false
    },
    checkBoothServices() {
      this.fair.tasks.forEach(task => {
        if (task.type === 'task') {
          if (task.boothServices === undefined) {
            task.boothServices = []
          }
          this.boothServices.forEach(boothService => {
            let check = task.boothServices.find(
              item => item.id === boothService.id
            )
            if (check === undefined) {
              task.boothServices.push({
                hidden: false,
                required: task.required,
                id: boothService.id
              })
            }
          })
        }
      })
    },
    countDownChanged(dismissCountDown) {
      this.successMessageDismissCountdown = dismissCountDown
    },
    setFairSeries(options) {
      ApiService.getFairSeries().then(response => {
        while (options.length > 0) {
          options.pop()
        }
        options.push({
          value: '',
          text: '-'
        })
        for (var i = 0; i < response.data.length; i++) {
          options.push({
            value: response.data[i]._id,
            text: response.data[i].titleDe
          })
        }
      })
    },
    getTaskDefinitions() {
      ApiService.getTaskDefinitions().then(response => {
        this.inactiveSteps = response.data
        this.inactiveSteps.forEach(step => {
          step.type = 'task'
        })

        this.inactiveSteps.sort((a, b) => {
          if (a.displayNameDe < b.displayNameDe) {
            return -1;
          }
          if (a.displayNameDe > b.displayNameDe) {
            return 1;
          }
          return 0;
        });

        ApiService.getTaskTitles().then(response => {
          this.inactiveTaskTitles = response.data
          this.inactiveTaskTitles.forEach(step => {
            step.type = 'taskTitle'
          })

          this.inactiveTaskTitles.sort((a, b) => {
            if (a.titleDe < b.titleDe) {
              return -1;
            }
            if (a.titleDe > b.titleDe) {
              return 1;
            }
            return 0;
          });

          this.updateInactiveSteps()

          if (this.boothServices.length === 0) {
            ApiService.getBoothServices().then(response => {
              this.boothServices = response.data
              this.checkBoothServices()
            })
          } else {
            this.checkBoothServices()
          }
        })
      })
    },
    updateInactiveSteps() {
      if (this.fair.tasks.length > 0) {
        let tasksIds = []
        for (let idx in this.fair.tasks) {
          tasksIds.push(this.fair.tasks[idx]._id)
        }
        this.inactiveSteps = this.inactiveSteps.filter(item => {
          return tasksIds.indexOf(item._id) == -1
        })
        this.inactiveTaskTitles = this.inactiveTaskTitles.filter(item => {
          return tasksIds.indexOf(item._id) == -1
        })
      }
    },
    setEditStep(task) {
      this.editStep = cloneDeep(task);
      this.$root.$emit('modal:editTask:show')
    },
    markTaskForDeletion(task) {
      this.deleteTask = task
      this.$root.$emit('modal:deleteTask:show')
    },
    doDeleteTask() {
      const idx = this.fair.tasks.indexOf(this.deleteTask)
      if (idx > -1) {
        this.fair.tasks.splice(idx, 1)
        this.getTaskDefinitions()
      }
      this.$root.$emit('modal:deleteTask:hide')
      this.processStepError = false
    },
    reopenStep(step) {
      // clone object
      this.editFlowStep = JSON.parse(JSON.stringify(step))
    },
    updateFlowStep() {
      let step = this.$refs.stepForm.value
      if (step.uuid === undefined) {
        step.uuid = UUIDService.generateUUID(
          'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'
        )
        this.fair.steps.push(step)
      } else {
        for (let idx in this.fair.steps) {
          if (this.fair.steps[idx].uuid === step.uuid) {
            this.fair.steps[idx] = step
          }
        }
      }
      this.editFlowStep = {}
    },
    markFlowStepForDeletion(step) {
      this.deleteFlowStep = step
      this.$root.$emit('modal:deleteFlowStep:show')
    },
    doDeleteFlowStep() {
      let step = this.deleteFlowStep
      this.fair.steps = this.fair.steps.filter(item => {
        return item.uuid != step.uuid
      })
      if (this.editFlowStep.uuid == this.deleteFlowStep.uuid) {
        this.editFlowStep = {}
      }
      this.deleteFlowStep = {}
      this.$root.$emit('modal:deleteFlowStep:hide')
    },

    reopenDoc(doc) {
      // clone object
      this.editDoc = JSON.parse(JSON.stringify(doc))
    },
    markDocForDeletion(doc) {
      this.deleteDoc = doc
      this.$root.$emit('modal:deleteDoc:show')
    },
    doDeleteDoc(doc) {
      this.closeModal('deleteDoc')
      this.fair.documents = this.fair.documents.filter(item => {
        return item.uuid != doc.uuid
      })
      if (this.editDoc.uuid == this.deleteDoc.uuid) {
        this.editDoc = {}
      }
      this.deleteDoc = {}
    },
    updateDoc() {
      let doc = this.$refs.docForm.value
      if (doc.uuid === undefined) {
        doc.uuid = UUIDService.generateUUID(
          'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'
        )
        this.fair.documents.push(doc)
      } else {
        for (let idx in this.fair.documents) {
          if (this.fair.documents[idx].uuid === doc.uuid) {
            this.fair.documents[idx] = doc
          }
        }
      }
      ApiService.updateFairDocs({
        docs: this.fair.documents,
        id: this.fair._id
      })
      this.editDoc = {}
    },
    tabClicked() {
      return
    },
    tabChanged() {
      return
    },
    getFairValidationRules() {
      return [
        {
          value: this.fair.displayNameDe,
          required: true,
          errorKey: 'displayNameDe',
          tab: 'messedaten'
        },
        {
          value: this.fair.displayNameFr,
          required: true,
          errorKey: 'displayNameFr',
          tab: 'messedaten'
        },
        {
          value: this.fair.displayNameEn,
          required: true,
          errorKey: 'displayNameEn',
          tab: 'messedaten'
        },
        {
          value: this.fair.idCode,
          required: true,
          errorKey: 'idCode',
          tab: 'messedaten'
        },
        {
          value: this.fair.fairSeries,
          required: true,
          errorKey: 'fairSeries',
          tab: 'messedaten'
        },
        {
          value: this.fair.emailTeam,
          required: true,
          errorKey: 'emailTeam',
          tab: 'messedaten'
        },
        {
          value: this.fair.idTeam,
          required: true,
          errorKey: 'idTeam',
          tab: 'messedaten'
        },
        {
          value: this.fair.defaultRegistrationUrlDe,
          required: true,
          errorKey: 'defaultRegistrationUrlDe',
          tab: 'messedaten'
        },
        {
          value: this.fair.defaultRegistrationUrlFr,
          required: true,
          errorKey: 'defaultRegistrationUrlFr',
          tab: 'messedaten'
        },
        {
          value: this.fair.defaultRegistrationUrlEn,
          required: true,
          errorKey: 'defaultRegistrationUrlEn',
          tab: 'messedaten'
        },
        {
          value: this.fair.duration,
          required: true,
          errorKey: 'duration',
          type: 'daterange',
          tab: 'messedaten'
        },
        {
          value: this.fair.publish,
          required: true,
          errorKey: 'publish',
          type: 'daterange',
          tab: 'messedaten'
        },
        {
          value: this.fair.registrationDeadline,
          required: true,
          errorKey: 'registrationDeadline',
          type: 'date',
          tab: 'messedaten',
          customRule: new Promise((resolve, reject) => {

            if (this.fair.publish.end !== undefined &&
            this.fair.publish.end !== null &&
            this.fair.publish.end.trim().length !== 0 &&
            this.fair.registrationDeadline !== undefined &&
            this.fair.registrationDeadline !== null &&
            this.fair.registrationDeadline.trim().length !== 0 &&
                new Date(this.fair.registrationDeadline).getTime() >
                new Date(this.fair.publish.end).getTime()) {
                  reject('Der Anmeldeschluss kann nicht nach dem Publikationsdatum sein!');
              }

            resolve();
          })
        }
      ]
    },
    saveFair() {
      const that = this
      FormValidator.validateForm(
        this.getFairValidationRules(),
        this.errors
      ).then(() => {
        if (
          this.fair.tasks.length > 0 &&
          this.fair.tasks[0].type !== 'taskTitle'
        ) {
          this.processStepError = true
          return
        } else {
          let action = this.fair._id ? 'updateFair' : 'createFair'
          let allowedStates = [200, 201]

          ApiService[action](this.fair).then(
            result => {
              this.$store.dispatch('fair/markForReload')
              if (allowedStates.includes(result.status)) {
                this.successMessageDismissCountdown = 5
                that.setCurrentFair(result.data.fair)
              }
            },
            error => {
              console.warn(error)
            }
          )
        }
      })
    },
    addInfotext() {
      this.editStep.infoTexts.push({})
    },
    markInfoTextForDeletion(index) {
      this.deleteInfoText = index;
      this.$root.$emit('modal:deleteInfoText:show')
    },
    doDeleteInfoText() {
      console.info('Remove item at: ' + this.deleteInfoText.toString())
      this.editStep.infoTexts.splice(this.deleteInfoText, 1)
      this.deleteInfoText = null
      this.$root.$emit('modal:deleteInfoText:hide')
    },
    closeModal(id) {
      this.$root.$emit(`modal:${id}:hide`)
    },
    setImageDe(file) {
      this.fair.logoDe = file.dataUrl
    },
    setImageFr(file) {
      this.fair.logoFr = file.dataUrl
    },
    setImageEn(file) {
      this.fair.logoEn = file.dataUrl
    },
    clearImage(e) {
      this.fair[e.currentTarget.getAttribute('data-image')] = null
    },
    setCurrentFair(fair) {
      this.fair = fair
      //fix old task definitions
      if (this.fair.tasks !== undefined) {
        this.fair.tasks.forEach(task => {
          if (task.type === undefined) {
            task.type = 'task'
          }
        })
      }
      //fix old registration url
      if (
        this.fair.defaultRegistrationUrl !== undefined &&
        (this.fair.defaultRegistrationUrlDe === undefined ||
          this.fair.defaultRegistrationUrlDe === null)
      ) {
        this.fair.defaultRegistrationUrlDe = this.fair.defaultRegistrationUrl
      }

      //fix old logo
      if (
        this.fair.logo !== undefined &&
        (this.fair.logoDe === undefined || this.fair.logoDe === null)
      ) {
        this.fair.logoDe = this.fair.logo
      }

      this.checkBoothServices()
      this.updateInactiveSteps()
    }
  },
  mounted() {
    this.getTaskDefinitions()
    if (this.$route.params.id) {
      ApiService.getFair(this.$route.params.id).then(res => {
        this.setCurrentFair(res.data)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/css/variables.scss';

.o-admin__fair {
  padding: 6rem 0;
}

.list-group-item {
  padding: 0.333rem 0;
  vertical-align: center;
  display: block;

  &:nth-child(even) {
    background-color: #f7f6f3;
  }

  &.list-group-item__tasktitle {
    border-top: 2px solid $brand-gray;
  }
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bos-timeflow {
  text-align: center;
  list-style: none;
  display: inline-table;
  margin: 0 0 4rem 0;

  li {
    display: inline;
    margin: 0;

    span {
      display: block;
      float: left;
      height: 44px;
      background: rgba(104, 115, 116, 0.3);
      text-align: center;
      padding: 14px 10px 0 30px;
      position: relative;
      margin: 0 4px 0 0;

      font-size: $timeflow-font-size;
      text-decoration: none;
      color: #fff;

      &:after {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid rgba(104, 115, 116, 0.3);
        position: absolute;
        right: -20px;
        top: 0;
        z-index: 1;
      }

      &:before {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    &:first-child span {
      padding-left: 24px;

      &:before {
        display: none;
      }
    }

    &:last-child span {
      padding-right: 20px;

      &:after {
        display: none;
      }
    }

    &.active span {
      background: rgba(46, 150, 153, 0.7);

      &:after {
        border-left-color: rgba(46, 150, 153, 0.7);
      }
    }
  }
}

.top-buttons {
  float: right;
  text-align: right;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

hr {
  margin: 1.333rem 0 4rem 0;
  border: none;
  border-bottom: 1px solid #c9c9c9;
}

.empty {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 0.333rem;

  span {
    display: block;

    &:after {
      display: block;
      width: 100%;
      content: 'hierher ziehen';
      text-align: center;
      color: rgba(0, 0, 0, 0.3);
    }
  }
}

.boothservices {
  .o-grid {
    & > div {
      padding: 4px 0;
    }

    &:nth-child(even) {
      background-color: #f7f6f3;
    }
  }
}

span.serviceGroup {
  color: #666;
  font-size: 0.9em;
  border: 1px solid #ccc;
  padding: 2px 4px;
  border-radius: 4px;
}



.processStepError {
  color: red;
  margin-bottom: 10px;
}

  .bos-button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .ellipsis {
    overflow:hidden;
    text-overflow: ellipsis;
  }

  h3 {
    font-size: 1.5rem;
  }
</style>
